// Append Bud Link UTM parameters to an outbound partner URL so downstream
// analytics (Trulieve, Sunnyside, Curaleaf, etc.) can attribute
// conversions back to us. Preserves any UTM values the URL already has
// (never clobber a link a partner already tagged) and gracefully
// no-ops for non-URL strings (data:, mailto:, malformed, empty).
//
// Default scheme:
//   utm_source   = "budlink"
//   utm_medium   = "organic"   (regular product cards)
//                = "sale"       (Sale Detail cards)
//   utm_campaign = ""           (empty for organic)
//                = sale.id      (Sale Detail cards)
//   utm_content  = optional     (e.g. "basket-cta" vs "card")
export const withUtm = (
  url,
  { source = "budlink", medium = "organic", campaign = "", content = "" } = {},
) => {
  if (!url || typeof url !== "string") return url;
  try {
    const u = new URL(url);
    if (!u.searchParams.has("utm_source")) u.searchParams.set("utm_source", source);
    if (!u.searchParams.has("utm_medium")) u.searchParams.set("utm_medium", medium);
    if (campaign && !u.searchParams.has("utm_campaign")) {
      u.searchParams.set("utm_campaign", campaign);
    }
    if (content && !u.searchParams.has("utm_content")) {
      u.searchParams.set("utm_content", content);
    }
    return u.toString();
  } catch {
    return url;
  }
};
